module.exports = __webpack_public_path__ + "static/img/9.2c346c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/9.png
// module id = FSx9
// module chunks = 0